import { UnresolvedTimeframe, getTimeframeLabel, type TimeframeEnumValue } from '@squaredup/timeframes';
import { EditorSteps } from '../../../constants';
import { useDataStreamSupportedTimeframes } from '../../../hooks/useDataStreamSupportedTimeframes';
import type { StepWithCondition } from '../../../hooks/useTileEditorSteps';
import { TimeframeStep } from './TimeframeStep';

const getTimeframeStepLabel = (
    supportedTimeframes: boolean | TimeframeEnumValue[],
    inheritedTimeframe: UnresolvedTimeframe,
    configTimeframe?: UnresolvedTimeframe
): string => {
    if (supportedTimeframes === false) {
        return 'Not supported';
    }

    if (configTimeframe) {
        if (configTimeframe === 'none') {
            return 'None';
        }
        return `${getTimeframeLabel(configTimeframe)} (Fixed)`;
    }

    return `${getTimeframeLabel(inheritedTimeframe)} (Dashboard)`;
};

interface UseTimeframeStepParameters {
    isLoading: boolean;
    hasDataStream: boolean;
    isConfigured: boolean;
    dataStreamId?: string;
    inheritedTimeframe: UnresolvedTimeframe;
    configTimeframe?: UnresolvedTimeframe;
}

/**
 * Create an object representing a timeframe step.
 */
export const useTimeframeStep = ({
    isLoading,
    hasDataStream,
    isConfigured,
    dataStreamId,
    inheritedTimeframe,
    configTimeframe
}: UseTimeframeStepParameters): StepWithCondition => {
    const supportedTimeframes = useDataStreamSupportedTimeframes(dataStreamId);
    
    const isEnabled = !isLoading && hasDataStream && supportedTimeframes !== false && isConfigured;
    
    const sublabel = getTimeframeStepLabel(supportedTimeframes, inheritedTimeframe, configTimeframe);

    return {
        name: EditorSteps.timeframe,
        isEnabled,
        Sublabel: () => <>{sublabel}</>,
        sublabelProps: {},
        Content: TimeframeStep,
        contentProps: {}
    };
};
